import React, { useState } from "react";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { connect } from "react-redux";

function SingleCartItem(props) {
  const [quantity, setQuantity] = useState(props.item.quantity);

  const handelQuantityIncrease = (id) => {
    setQuantity(quantity + 1);
    props.addQuantity({ quantity: quantity + 1, id });
  };

  const handelQuantityDecrease = (id) => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
      props.decreaseQuantity({ quantity: quantity - 1, id });
    }
  };

  return (
    <React.Fragment>
      <div className="col-md-3 col-12 text-center">
        <img
          className="img-fluid img-thumbnail my_img"
          src={props.item.image}
          alt="..."
        />
      </div>
      <div className="col-md-9 col-12 my-3 my-sm-0 mx-5 mx-sm-0 ms-0">
        <p className="m-0"> {props.item.title} </p>
        <div>
          <span>Price : {props.item.discounted_price}</span> <br />
          <span>Quantity : </span> &nbsp;
          <button
            type="button"
            style={{ border: "none" }}
            onClick={() => {
              handelQuantityDecrease(props.item.id);
            }}
          >
            <AiFillMinusCircle />
          </button>
          &nbsp; &nbsp;
          {quantity}
          &nbsp; &nbsp;
          <button
            type="button"
            style={{ border: "none" }}
            onClick={() => {
              handelQuantityIncrease(props.item.id);
            }}
          >
            <AiFillPlusCircle />
          </button>
        </div>
        <div className="d-flex align-items-center justify-content-between me-5 me-sm-0">
          <button
            type="button"
            className="btn btn-dark d-block"
            onClick={() => {
              props.removeFromCart(props.item.id);
            }}
          >
            Remove From Cart
          </button>
          <p className="me-5 pt-3 fw-bolder ">
            Rs. {props.item.discounted_price * quantity}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapDispacthToProps = (dispatch) => {
  return {
    addQuantity: (val) =>
      dispatch({ type: "ADD_QUANTITY_TO_PRODUCT", payload: val }),
    decreaseQuantity: (val) =>
      dispatch({ type: "DECREASE_QUANTITY_FROM_PRODUCT", payload: val }),
    removeFromCart: (val) =>
      dispatch({ type: "REMOVE_FROM_CART", payload: val }),
  };
};

export default connect(null, mapDispacthToProps)(SingleCartItem);
